
import { Vue, Component, Prop } from 'vue-property-decorator'
import { Getter } from 'vuex-class'

// Enums
import { ReportStateType } from '@/enums/ReportStateType'

// Interfaces
import { Field as FieldInterface } from '@/interfaces/Report'

@Component
export default class Field extends Vue {
  @Getter('canShowValues', { namespace: 'report' }) canShowValues
  @Getter('canEditValues', { namespace: 'report' }) canEditValues
  @Getter('canShowDropoffValues', { namespace: 'report' }) canShowDropoffValues
  @Getter('canEditDropoffValues', { namespace: 'report' }) canEditDropoffValues
  @Getter('isFinished', { namespace: 'report' }) isFinished
  @Getter('isWaiting', { namespace: 'report' }) isWaiting
  @Getter('isReturn', { namespace: 'report' }) isReturn

  @Prop() field
  @Prop({ type: Boolean, default: false }) dropoff: boolean
  @Prop({ type: String, default: '' }) state: string
  @Prop({ type: String, default: 'first' }) position: string
  @Prop({ type: Number }) section: number

  get fieldClasses() {
    const classes = []
    if ((this.position === 'first' && !this.canEditValues) || (this.position === 'second' && !this.field.dropoff)) {
      classes.push('is-locked')
    }
    return classes
  }

  get fieldPlaceholder() {

    if (this.position === 'first' && !this.field.value && !this.canEditValues) {
      return this.$t('global.field.empty')
    }

    if ((this.position === 'second' && !this.field.dropoff && !this.field.value) || this.state === 'finished') {
      return this.$t('global.field.empty')
    }

    return this.$t('global.field.placeholder')
  }

  get isLocked(): boolean {
    return (this.position === 'first' && !this.canEditValues)
      || (this.position === 'second' && !this.field.dropoff)
      || (this.state === ReportStateType.Finished)
  }

  get isFirst(): boolean {
    return this.position === 'first'
  }

  get isSecond(): boolean {
    return this.position === 'second'
  }

  get isReadOnly() {
    if (this.isSecond && this.state !== ReportStateType.Finished) {
      return !this.field.dropoff
    }
    if (this.isFirst && this.state !== ReportStateType.Finished) {
      return !this.canEditValues
    }
    return this.state === ReportStateType.Finished
  }

  get currentValue() {
    return this.isSecond ? (this.field.dropoff ? this.field.dropoffValue : this.field.value) : this.field.value
  }

  updateField(field, val) {

    const emitter: FieldInterface = {
      id: field.id,
      name: field.name,
      section: this.section
    }

    const _val = (field.type === 'boolean') ? JSON.parse(val) : val // tslint:disable-line

    switch (this.state) {
      case ReportStateType.Waiting:
        field.value = _val
        emitter.value = val
        break
      case ReportStateType.Return:
        field.dropoffValue = _val
        emitter.dropoff_value = val
        break
    }

    if (!this.state) {
      field.value = _val
      emitter.value = val
    }

    field.edited = true
    this.$emit('change', emitter)
  }
}
